<template>
  <div class="timeuntil">
    <div class="event">Days Until {{ event }}</div>
    <div class="until">{{ daysUntil }}</div>
    <br>
  </div>
</template>

<script>
  import { formatDistanceStrict } from "date-fns"
  export default {
    name: 'TimeUntil',
    props: {
      event: {
        type: String,
        required: true
      },
      year: {
        type: Number,
        required: true,
        validator: (v) => v >= 2000
      },
      month: {
        type: Number,
        required: true,
        validator: (v) => v >= 1 && v <= 12
      },
      day: {
        type: Number,
        required: true,
        validator: (v) => v >= 1 && v <= 31
      }
    },
    data() {
      return { now: new Date() }
    },
    computed: {
      daysUntil() {
        return formatDistanceStrict(
          this.now,
          new Date(this.year, this.month - 1, this.day, 0, 0),
          { unit: "day" }
        )
      }
    },
    created() {
      this.timer = setInterval(() => { this.now = new Date() }, 60000)
    },
    beforeUnmount() {
      clearInterval(this.timer)
    }
  }
</script>